<div class='payment-processor-main' data-cy="payment-processor-container">
  <mat-progress-spinner *ngIf="tableModel === undefined" style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)" diameter="100" mode="indeterminate" data-cy="payment-processor-loading-spinner"></mat-progress-spinner>
  <mat-grid-list *ngIf="tableModel !== undefined" cols="6" rowHeight="100%" style="height:100%;" data-cy="payment-processor-grid">
    <mat-grid-tile colspan="2" data-cy="payment-processor-list-tile">
      <mat-card appearance="outlined" style="width:100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="payment-processor-list-card">
        <span class="configuration-section-title" data-cy="payment-processor-list-title">Payment Processors</span>
        <div style="flex: 1; max-height: 100%; overflow-y: hidden;" data-cy="payment-processor-list-content">

          <mat-form-field style="width:100%; margin-top: 3px;" data-cy="payment-processor-client-field">
            <mat-label data-cy="payment-processor-client-label">Practice (Licensee)</mat-label>
            <mat-select [(value)]="selectedClient" (selectionChange)="onChangeClient($event)" data-cy="payment-processor-client-select">
              <mat-option *ngFor="let client of clientList" [value]="client" data-cy="payment-processor-client-option">
                {{client.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="width:100%" data-cy="payment-processor-location-field">
            <mat-label data-cy="payment-processor-location-label">Practice Locations</mat-label>
            <mat-select [(value)]="selectedLocation" (selectionChange)="onChangeLoc('')" data-cy="payment-processor-location-select">
              <mat-option *ngFor="let loc of locationList" [value]="loc" data-cy="payment-processor-location-option">
                {{loc.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="locationList.length > 0" data-cy="payment-processor-table-container">

            <app-tdo-table #processorTable [sortActive]="true" [isSearchable]="false" *ngIf="tableModel !== undefined" [tdoTableModel]="tableModel" (actionClick)="onTdoTableItemActionClick($event)" (itemSelected)="onTdoTableItemClick($event)" data-cy="payment-processor-table"></app-tdo-table>
          </div>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" data-cy="payment-processor-detail-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="payment-processor-detail-card">
        <mat-card-content data-cy="payment-processor-detail-content">
          <div style="max-width: 700px;" data-cy="payment-processor-form-container">
            <span class="configuration-section-title" data-cy="payment-processor-detail-title">Processor Information</span>
            <app-tdo-configuration-action-bar
              #actionBar
              *ngIf="(this.locationList.length > 0)"
              [showEdit]="(!isEditing && this.selectedProcessor != null)"
              (editClick)="onEdit($event)"
              [saveDisabled]="saveDisabled || (selectedProcessor ? (selectedProcessor.Name ? selectedProcessor.Name : '') : '').trim() === '' || !selectedProcessor.enumARProcessorID"
              [showSave]="!saveDisabled"
              [showCancel]="!saveDisabled"
              (saveClick)="onSave($event)"
              (cancelClick)="onCancel($event)"
              (newClick)="onNewProcessor($event)"
              [showAdd]="false"
              [newHidden]="false"
              data-cy="payment-processor-action-bar">
            </app-tdo-configuration-action-bar>

            <div *ngIf="this.selectedProcessor" style="display:flex; flex-direction: column; height: 775px" data-cy="payment-processor-form">

              <div style="flex: 1; overflow: auto" data-cy="payment-processor-form-fields">
                <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="payment-processor-name-field">
                  <mat-label data-cy="payment-processor-name-label">Name</mat-label>
                  <input matInput [(ngModel)]="this.selectedProcessor.Name" [disabled]="!this.isEditing" data-cy="payment-processor-name-input">
                </mat-form-field>

                <mat-form-field style="width:100%; margin-top: 3px;" data-cy="payment-processor-type-field">
                  <mat-label data-cy="payment-processor-type-label">Type</mat-label>
                  <mat-select [(value)]="selectedProcessor.enumARProcessorID" (selectionChange)="setProcessorType($event.value)" [disabled]="!this.isEditing" data-cy="payment-processor-type-select">
<!--                    || selectedProcessor.PaymentProcessorId || this.getDevicePairedStatusBoolean() -->
                    <mat-option *ngFor="let type of enumProcessors" [value]="type.ValidValueItemId" data-cy="payment-processor-type-option">
                      {{ type.ItemDisplayValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <div *ngIf="selectedProcessor && this.isDevice()" data-cy="payment-processor-device-container">

                  <div *ngIf="this.selectedProcessor.DeviceNumber" data-cy="payment-processor-device-number-container">
                    <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="payment-processor-device-number-field">
                      <mat-label data-cy="payment-processor-device-number-label">Device Number</mat-label>
                      <input matInput [(ngModel)]="this.selectedProcessor.DeviceNumber" [disabled]="true" data-cy="payment-processor-device-number-input">
                    </mat-form-field>
                  </div>

                </div>

                <div *ngIf="this.showSelectedProcessorJSONParams()" data-cy="payment-processor-params-container">

                  <div *ngFor="let item of connectionParametersJSON | keyvalue; let i=index; trackBy:trackByFn" data-cy="payment-processor-param-{{i}}">
                    <app-tdo-input *ngIf="item.key !== 'IsPaired'" [(ngModel)]="connectionParametersJSON[item.key]" style="width:100%" [placeholder]="item.key" [disabled]="!this.isEditing || this.getDevicePairedStatusBoolean()" data-cy="payment-processor-param-input-{{i}}"></app-tdo-input>
                  </div>

                  <div *ngIf="this.isDevice()" data-cy="payment-processor-device-actions">
                    <button [disabled]="!this.isEditing || this.getDevicePairedStatusBoolean()" (click)="pairDevice($event)" style="margin-right: 2px;" class="tdo-button tdo-save" data-cy="payment-processor-pair-button">Pair Device</button>
                    <button [disabled]="!this.isEditing || !this.getDevicePairedStatusBoolean()" (click)="unPairDevice($event)" style="margin-right: 2px;" class="tdo-button tdo-save" data-cy="payment-processor-unpair-button">UnPair Device</button>

                    <div data-cy="payment-processor-pair-status">
                      Device Paired: {{ this.getDevicePairedStatusText() }}
                    </div>
                    <br>
                    <span style="font-size: 24px" data-cy="payment-processor-workstations-title">Device Workstations</span>
                    <app-tdo-table #workstationTable [sortActive]="true" [isSearchable]="false" *ngIf="tableModelWorkstation !== undefined" [tdoTableModel]="tableModelWorkstation" (actionClick)="onTdoTableItemActionClickWorkstation($event)" (itemSelected)="onTdoTableItemWorkstationClick($event)" data-cy="payment-processor-workstations-table"></app-tdo-table>
                    <div style="display: flex; padding-top:10px" data-cy="payment-processor-workstation-actions">
                      <div style="flex: 1; text-align: right" data-cy="payment-processor-add-workstation-container">
                        <button [disabled]="!this.isEditing" style="margin-right: 2px;" (click)="openPaymentProcessorDeviceDialog('')" class="tdo-button tdo-save" data-cy="payment-processor-add-workstation-button">Add Workstation</button>
                      </div>
                    </div>
                  </div>
                </div>


                <!--is location default-->
                <mat-checkbox *ngIf="selectedProcessor && isDevice()" [(ngModel)]="selectedProcessor.isLOCdefault" [disabled]="!this.isEditing" data-cy="payment-processor-default-checkbox">Is Location Default</mat-checkbox>

              </div>


            </div>
            <div *ngIf="this.isLoading" data-cy="payment-processor-detail-loading">
              <mat-spinner style="margin-left: auto; margin-right: auto;" data-cy="payment-processor-detail-spinner"></mat-spinner>
            </div>

          </div>

        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>


